module.exports = __webpack_public_path__ + "static/media/inventory.3387e165.svg";